module.exports = __webpack_public_path__ + "img/logo-white.ca7c9b03.svg";